import dashboard from './dashboard';
import { NavItemType } from 'types';
import addressBook from './address-book';
import forms from './forms';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [dashboard, addressBook, forms]
};

export default menuItems;
